import React, { Component } from 'react';
import BigCalendar from 'react-big-calendar';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { Form } from 'react-redux-form';
import moment from 'moment';
import Loading from '../ui/loading-spinner';

import Filters from './filters';
import CalendarHeader from './header';
import EventList from './event-list';

// Setup the localizer by providing the moment (or globalize) Object
// to the correct localizer.
BigCalendar.setLocalizer(
    BigCalendar.momentLocalizer(moment) // or globalizeLocalizer
);

//This will get rid of hte deprecation warning in the console.
//If ever moment has been updated the format would need to change.
moment.suppressDeprecationWarnings = true;

const Event = ({ event }) => {
    let eventTitle = event.formattedTitle;

    return event.url ? (
        <Link to={event.url} className={'rbc-event-link ' + event.className}>
            <span className="rbc-event-span" title={event.qualifiedName}>
                {eventTitle}
            </span>
        </Link>
    ) : (
        <span
            title={event.qualifiedName}
            className={'rbc-event-link rbc-event-span ' + event.className}
        >
            {eventTitle}
        </span>
    );
};

class Calendar extends Component {
    componentDidMount() {
        this.props.onLoadCalendarLocations('calendarFilters');
        const paramObj = {
            startDate: moment()
                .subtract(45, 'day')
                .format('YYYY-MM-DD'),
            endDate: moment()
                .add(45, 'day')
                .format('YYYY-MM-DD')
        };
        this.props.fetchCalendarThunk(paramObj);
        const windowStart = moment(this.props.focus).subtract(45, 'day');
        this.props.setEventWindowStart(windowStart);
        const windowEnd = moment(this.props.focus).add(45, 'day');
        this.props.setEventWindowEnd(windowEnd);
    }

    componentWillUnmount() {
        this.props.resetCalEvents();
    }

    render() {
        return this.props.getCalLoading ? (
            <Loading />
        ) : (
            <div>
                <div
                    id="overlay-bg"
                    onClick={this.props.toggleCalendarFilters}
                    className={classNames({
                        'is-active': this.props.calendarFiltersActive
                    })}
                />

                <Form
                    onSubmit={this.props.applyFilters}
                    model="calendarFilters"
                >
                    <Filters
                        closeOnClick={this.props.toggleCalendarFilters}
                        model="calendarFilters"
                        isActive={this.props.calendarFiltersActive}
                        resetCalendarBtn={this.props.resetCalendarBtn}
                    />
                </Form>

                <CalendarHeader
                    userInfo={this.props.userInfo}
                    calendarToggle={this.props.calendarToggle}
                    setCalendarView={this.props.setCalendarView}
                    calendar={this.props.calendar}
                    setCalendarActive={this.props.setCalendarActive}
                    filters={this.props.filters}
                    focus={this.props.focus}
                    view={this.props.view}
                    eventWindowStart={this.props.eventWindowStart}
                    eventWindowEnd={this.props.eventWindowEnd}
                    setFocusDate={this.props.setFocusDate}
                    toggleFilter={this.props.toggleFilter}
                    toggleCalendarFilters={this.props.toggleCalendarFilters}
                    calendarFiltersActive={this.props.calendarFiltersActive}
                    fetchCalendarThunk={this.props.fetchCalendarThunk}
                    setEventWindowStart={this.props.setEventWindowStart}
                    setEventWindowEnd={this.props.setEventWindowEnd}
                    setFocusDateDirect={this.props.setFocusDateDirect}
                />

                {this.props.calendar ? (
                    <BigCalendar
                        events={this.props.events}
                        defaultView="month"
                        popup
                        date={new Date(this.props.focus)}
                        onNavigate={new Date(this.props.focus)}
                        toolbar={false}
                        components={{
                            event: Event
                        }}
                    />
                ) : (
                    <EventList
                        events={this.props.events}
                        focus={this.props.focus}
                        view={this.props.view}
                    />
                )}
            </div>
        );
    }
}

export default Calendar;



// WEBPACK FOOTER //
// ./src/components/calendar/index.js